<template>
    <section class="section section-cta">
        <div class="container">
            <hr class="cta-separator" />
            <div class="cta-box">
                <a href="#" class="btn btn-primary big">Follow Us On Instagram</a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'CTASection',
};
</script>



// WEBPACK FOOTER //
// src/components/CTASection.vue